import dynamic from 'next/dynamic'
import { createContext, useContext, useMemo, useState } from 'react'

const DialogConfirmation = dynamic(() => import('@bluheadless/ui/src/molecules/dialog/dialog-confirmation'), {
	ssr: false,
})

const ConfirmDialogContext = createContext()

const ConfirmDialogProvider = ({ children }) => {
	const [confirmation, setConfirmation] = useState({
		title: '', // title of the dialog
		open: false,
		confirm: null, // function to call when the user confirms
		cancel: null, // function to call when the user cancels
		actionName: null, // name of the action that triggered the dialog
	})

	const value = useMemo(() => [confirmation, setConfirmation], [confirmation])

	return (
		<ConfirmDialogContext.Provider value={value}>
			{children}
			<DialogConfirmation
				open={confirmation.open}
				title={confirmation.title}
				actions={{
					confirmed: confirmation.confirm,
					cancelled: confirmation.cancel,
				}}
				actionName={confirmation.actionName}
			/>
		</ConfirmDialogContext.Provider>
	)
}

export default ConfirmDialogProvider

export const useConfirmDialogContext = () => {
	const confirmDialogContextValue = useContext(ConfirmDialogContext)

	if (!confirmDialogContextValue)
		console.warn(
			`ConfirmDialog context value is missing. Verify that ConfirmDialogProvider is a parent of the current component.`
		)

	return confirmDialogContextValue
}
